// platform/app/src/lib/distribution.ts
import syncYmlRaw from '@ops/sync.yml?raw'
import skillsLockJson from '@root/skills-lock.json'
import { parseSyncYml, type ParsedSync, type SkillsLock } from '@loop3/sync'

export type DistributionCategory = 'workflows' | 'skills' | 'configs'
export type { ManagedFile } from '@loop3/sync'

const SYNC: ParsedSync = parseSyncYml(syncYmlRaw, skillsLockJson as SkillsLock)

export const DISTRIBUTION = SYNC.managedFiles
export const REPOS = SYNC.repos

/** Public GitHub URL for a source path in the l3-os monorepo. */
export function githubSourceUrl(source: string): string {
  return `https://github.com/Loop3Studio/l3-os/blob/main/${source}`
}
